import React from "react";
import { Row, Col, Input, Form } from "antd";
import PropTypes from "prop-types";
import TooltipComponent from "../../../../../../CommonComponents/Info/Tooltip/TooltipComponent";
import {
  GrantAgreementSectionLastHeading,
  GrantAgreementSubContent,
  InputWrapper,
  LabelWrapper,
  FormContainer,
  WrapLabel,
  InputMargin,
  ErrorMsgWrap,
  InputSection
} from "../../styles";
import FormBase from "../../../../../../CommonComponents/FormBase/FormBase";
import { tooltipAligner } from "../../../RecommendGrant/utils";
import { FormItem } from "../../../RecommendGrant/Component/TextBoxComponent/style";

export default class GranteeOrganizationContact extends FormBase {
  constructor(props) {
    super(props);
    this.state = {
      firstName: {
        value: this.props.granteeOrgFirstName || "",
        touched: false,
        valid: "",
        validationRules: {
          isRequired: true
        },
        messages: {
          isRequired: "Please provide contact's first name to continue."
        }
      },
      lastName: {
        value: this.props.granteeOrgLastName || "",
        touched: false,
        valid: "",
        validationRules: {
          isRequired: true,
          minLength: 2
        },
        messages: {
          isRequired: "Please provide contact's last name to continue.",
          minLength: "Last Name is too short. Please correct to proceed."
        }
      },
      email: {
        value: this.props.granteeOrgEmailAddr || "",
        touched: false,
        valid: "",
        validationRules: {
          isEmail: true,
        },
        messages: {
          isEmail:
            "Please enter a valid email address.",
        }
      },
      phone: {
        value: this.props.granteeOrgPhoneNumber || "",
        touched: false,
        valid: "",
        validationRules: {
          optionDependentWith: 'email'
        },
        messages: {
          optionDependentWith: "Please enter phone number"
        }
      },
      customValidationFlag: ""
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
    this.runFormValidation = this.runFormValidation.bind(this);
  }

  componentDidMount() {
    this.handleFormChange();
    this.firstInputField && this.firstInputField.focus();
  }


  componentDidUpdate(prevProps) {
    if(prevProps.individualValidator !== this.props.individualValidator) {
      this.runFormValidation();
      this.customValidation();
    }
  }

  handleFormChange() {
    this.props.storeContactData(this.formatData());
  }

  customValidation = () => {
    const { phone, email } = this.state;
    if(!phone.value && !email.value){
      this.setState({ customValidationFlag : "Please specify Phone number or Email Address to continue."});
    }
    else {
      this.setState({ customValidationFlag : ""});
    }
  }

  customHandleBlur = (event) => {
    const { value } = event.target;
    if(value) this.setState({ customValidationFlag : ""});
    this.handleBlur(event);
  }

  formatData = () => {
    const { firstName, lastName, phone, email } = this.state;

    return {
      data: {
        granteeOrgFirstName: firstName.value,
        granteeOrgLastName: lastName.value,
        granteeOrgEmailAddr: email.value,
        granteeOrgPhoneNumber: phone.value
      },
      isFormValid: this.checkFormValid(this.state)
    };
  };

  render() {
    const { firstName, lastName, phone, email, customValidationFlag } = this.state;

    return (
      <FormContainer hideRequiredMark>
        <Row>
          <Col lg={{ span: 12 }}>
            <GrantAgreementSectionLastHeading>
              Grantee organization contact
            </GrantAgreementSectionLastHeading>
            <GrantAgreementSubContent>
                Enter contact details for the grantee organization below. The more
                details you can provide, the quicker we can review your
                recommendation.
              <TooltipComponent
                id="granteeOrg"
                placement={tooltipAligner('#granteeOrg')}
                text="This should be an employee of the grantee organization who can answer questions related to this grant"
              />
            </GrantAgreementSubContent>
          </Col>
        </Row>
        <Row>
          <Col xl={{span: 8}} lg={{ span: 9 }} md={{ span: 8 }}>
            <WrapLabel>
              <InputMargin marginBottom='40px'>
                <Form.Item
                  colon={false}
                  label={<LabelWrapper for="txtFirstName">First Name</LabelWrapper>}
                >
                  <InputWrapper>
                    <InputSection
                      id="txtFirstName"
                      aria-label="First Name"
                      ref={(input) => { this.firstInputField = input; }}
                      role="textbox" 
                      maxLength={150}
                      name='firstName'
                      placeholder='Enter first name'
                      value={firstName.value}
                      onChange={e => this.handleInputChange(e)}
                      onBlur={e => this.handleBlur(e)}
                    />
                    {firstName.touched && firstName.valid && (
                      <ErrorMsgWrap>
                        {firstName.messages[firstName.valid]}
                      </ErrorMsgWrap>
                    )}
                  </InputWrapper>
                </Form.Item>
              </InputMargin>
            </WrapLabel>
          </Col>
          <Col xl={{span: 8}} lg={{ span: 9, offset: 1 }} md={{ span: 8, offset: 1 }}>
            <WrapLabel>
              <InputMargin>
                <Form.Item
                  colon={false}
                  label={<LabelWrapper for="txtLastName">Last Name</LabelWrapper>}
                >
                  <InputWrapper>
                    <InputSection
                      id="txtLastName"
                      name='lastName'
                      aria-label="last-name"
                      role="textbox"
                      placeholder='Enter last Name'
                      value={lastName.value}
                      maxLength={150}
                      minLength={2}
                      onChange={e => this.handleInputChange(e)}
                      onBlur={e => this.handleBlur(e)}
                    />
                    {lastName.touched && lastName.valid && (
                      <ErrorMsgWrap>
                        {lastName.messages[lastName.valid]}
                      </ErrorMsgWrap>
                    )}
                  </InputWrapper>
                </Form.Item>
              </InputMargin>
            </WrapLabel>
          </Col>
        </Row>
        <Row>
          <Col xl={{span: 8}} lg={{ span: 9 }} md={{ span: 8 }}>
            <WrapLabel>
              <InputMargin>
                <FormItem noMargin colon={false} label={<LabelWrapper for="txtPhoneNumber">Phone Number</LabelWrapper>}>
                  <InputWrapper>
                    <InputSection
                      id="txtPhoneNumber"
                      name='phone'
                      role="textbox"
                      placeholder='Enter phone number'
                      aria-label='phone-number'
                      maxLength={25}
                      value={phone.value}
                      onChange={e => this.handleInputChange(e)}
                      onBlur={e => this.customHandleBlur(e)}
                    />
                  </InputWrapper>
                </FormItem>
              </InputMargin>
            </WrapLabel>
          </Col>
          <Col xl={{span: 8}} lg={{ span: 9, offset: 1 }} md={{ span: 8, offset: 1 }}>
            <WrapLabel>
              <InputMargin>
                <FormItem noMargin colon={false} label={<LabelWrapper for="txtEmailId">Email Address</LabelWrapper>}>
                  <InputWrapper>
                    <InputSection
                      id="txtEmailId"
                      name='email'
                      role="textbox"
                      placeholder='Enter email address'
                      aria-label="email"
                      value={email.value}
                      maxLength={100}
                      onChange={e => this.handleInputChange(e)}
                      onBlur={e => this.customHandleBlur(e)}
                    />
                    {email.touched && email.valid && (
                      <ErrorMsgWrap>{email.messages[email.valid]}</ErrorMsgWrap>
                    )}
                  </InputWrapper>
                </FormItem>
              </InputMargin>
            </WrapLabel>
          </Col>
        </Row>
        <Row>
            <Col>
              {customValidationFlag && (
                <ErrorMsgWrap>{customValidationFlag}</ErrorMsgWrap>
              )}
            </Col>
          </Row>
      </FormContainer>
    );
  }
}

GranteeOrganizationContact.propTypes = {
  granteeOrgEmailAddr: PropTypes.string,
  granteeOrgFirstName: PropTypes.string,
  granteeOrgLastName: PropTypes.string,
  granteeOrgPhoneNumber: PropTypes.string,
  individualValidator: PropTypes.bool,
  storeContactData: PropTypes.func
}
